// @flow
import { Link } from "react-router-dom";
import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal } from "@fdr/static-ui/Typography";

export const RaceLinkAbbrContainer = styled(Link)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: ${buildColor("white", "100")};
  border: 1px solid ${buildColor("grey", "L2")};
  text-decoration: none;
  border-radius: 2px;
  height: 52px;
  width: 96px;
  padding-left: 12px;

  &:active {
    background-color: ${buildColor("grey", "100")};
  }
`;

export const RaceLinkAbbrWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopContainer = styled.div`
  display: flex;
  margin-bottom: 2px;
  height: 16px;
`;

export const PromoWrapper = styled.div`
  margin-left: 4px;
`;

export const RaceLabel = styled.label`
  font-size: 14px;
  letter-spacing: 0;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "D4")};
  font-weight: normal;
  line-height: 18px;
`;
